export const getBrand = () => {
  return window.location.hostname.endsWith('kotipuhtaaksi.fi') ? 'kp' : 'freska';
};
